module.exports = __webpack_public_path__ + "img/Ancestry (s).0bad9950.png";